import { render } from "./SettingsIcon.vue?vue&type=template&id=28e50f9e"
import script from "./SettingsIcon.vue?vue&type=script&lang=js"
export * from "./SettingsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__